import React, { useEffect, useState } from 'react';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper, Dialog, Card, CardContent, Grid } from '@mui/material';
import Sidebar from './Sidebar';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import AddUser from './AddUser';
import { useDispatch, useSelector } from 'react-redux';
import { getUserAction } from '../../store/actions';
import { useMediaQuery } from '@mui/material';

const UserManagement = () => {
  const dispatch = useDispatch();
  const isDesktop = useMediaQuery('(min-width: 900px)');
  const [openSignupDialog, setOpenSignupDialog] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const { successData } = useSelector((state) => state.getUserReducer);
  const users = successData?.data || [];

  const handleAddNewUser = () => {
    setEditingUser(null); // Ensure we're not in edit mode
    setOpenSignupDialog(true);
  };

  const handleEditUser = (user) => {
    setEditingUser(user);
    setOpenSignupDialog(true);
  };

  const handleCloseSignupDialog = () => {
    setOpenSignupDialog(false);
    setEditingUser(null);
  };

  const handleFormSubmitSuccess = () => {
    handleCloseSignupDialog();
    dispatch(getUserAction());
  };

  useEffect(() => {
    dispatch(getUserAction());
  }, [dispatch]);

  return (
    <Box sx={{ display: 'flex', position: 'relative' }}>
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: { xs: '15%', sm: '10%', md: '7%' },
          backgroundColor: 'background.default',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" component="h1" sx={{ color: '#343C6A', fontFamily: 'Mont', fontWeight: 'bold' }}>
            All Users
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddCircleOutlinedIcon sx={{ p: 1, bgcolor: '#E7EDFF', borderRadius: '50%', color: '#3C1ED5' }} />}
            sx={{
              backgroundColor: '#CBD6F9',
              color: '#232323',
              fontFamily: 'Poppins',
              borderRadius: '10px',
              padding: '20px',
            }}
            onClick={handleAddNewUser}
          >
            Add New User
          </Button>
        </Box>

        {isDesktop ? (
          <TableContainer component={Paper} sx={{ boxShadow: 'none', mt: '5%' }}>
            <Table sx={{ minWidth: 650, '& .MuiTableCell-root': { borderBottom: '1px solid #E6EFF5' } }}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#B5B7C0', fontFamily: 'Poppins' }}>
                      User
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#B5B7C0', fontFamily: 'Poppins' }}>
                      Email
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#B5B7C0', fontFamily: 'Poppins' }}>
                      Phone Number
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#B5B7C0', fontFamily: 'Poppins' }}>
                      Role
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#B5B7C0', fontFamily: 'Poppins' }}>
                      Action
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.length > 0 ? (
                  users.map((user) => (
                    <TableRow key={user.user_id}>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#292D32' }}>{user.full_name}</TableCell>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#292D32' }}>{user.email}</TableCell>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#292D32' }}>{user.mobile_no}</TableCell>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#292D32' }}>{user.role}</TableCell>
                      <TableCell>
                        <Button
                          size="small"
                          sx={{ backgroundColor: '#1814F3', color: '#fff' }}
                          onClick={() => handleEditUser(user)}
                        >
                          Edit
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No users found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Grid container spacing={2}>
            {users.length > 0 ? (
              users.map((user) => (
                <Grid item xs={12} sm={6} key={user.user_id}>
                  <Card variant="outlined" sx={{ borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)' }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ fontFamily: 'Poppins', fontWeight: 'bold' }}>
                        {user.full_name}
                      </Typography>
                      <Typography sx={{ fontFamily: 'Poppins', color: '#292D32' }}>Email: {user.email}</Typography>
                      <Typography sx={{ fontFamily: 'Poppins', color: '#292D32' }}>Phone: {user.mobile_no}</Typography>
                      <Typography sx={{ fontFamily: 'Poppins', color: '#292D32' }}>Role: {user.role}</Typography>
                      <Button
                        size="small"
                        sx={{ backgroundColor: '#1814F3', color: '#fff', mt: 2 }}
                        onClick={() => handleEditUser(user)}
                      >
                        Edit
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            ) : (
              <Typography align="center" sx={{ width: '100%', mt: 2 }}>
                No users found
              </Typography>
            )}
          </Grid>
        )}
      </Box>

      <Dialog open={openSignupDialog} onClose={handleCloseSignupDialog} maxWidth="md" fullWidth>
        <AddUser
          onClose={handleCloseSignupDialog}
          editMode={!!editingUser}
          userData={editingUser}
          onSuccess={handleFormSubmitSuccess}
        />
      </Dialog>
    </Box>
  );
};

export default UserManagement;
